import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { getText } from 'function/language';
import { getErrorMessage } from 'function/message';
import { RESPONSE_CODE } from 'types/const';
import isEmpty from 'utils/isEmpty';
import { clean, pluck } from 'utils/array';

/**
 * 목록
 */
const List = ({
  children,
  className,
  columns,
  message,
  showLoading,
  tableRef,
  ...props
}) => {
  /* state */
  // 하위 컬럼 목록
  const [childrenColumns, setChildrenColumns] = useState([]);
  // 컬럼 목록 (하위 포함)
  const [flatColumns, setFlatColumns] = useState([]);

  /* watch */
  useEffect(() => {
    setChildrenColumns(clean(pluck(columns, 'childrens')).flat());
    setFlatColumns(
      columns.reduce(
        (result, value) =>
          Array.isArray(value?.childrens)
            ? [...result, ...value.childrens]
            : [...result, value],
        []
      )
    );
  }, [columns]);

  /* view */
  return (
    <Table
      ref={tableRef}
      bordered
      responsive
      className={classNames(
        {
          'text-center': ['text-start', 'text-center', 'text-end'].every(
            value => !(className.table ?? '').split(' ').includes(value)
          )
        },
        { 'fs--1': !className.table?.includes?.('fs-') },
        className.table
      )}
      {...props}
    >
      <thead
        className={classNames(
          { 'bg-200': !className.thead?.includes?.('bg-') },
          { 'text-700': !className.thead?.includes?.('text-') },
          'align-middle',
          { 'border-300': !className.thead?.includes?.('border-') },
          className.thead
        )}
      >
        <tr>
          {columns.map((value, index) => (
            <th
              key={`columns${index}`}
              className={value?.className}
              colSpan={value?.childrens?.length ?? value?.colSpan ?? 1}
              rowSpan={
                childrenColumns.length > 0 && isEmpty(value?.childrens) ? 2 : 1
              }
              style={{
                whiteSpace: 'pre-line',
                ...value?.style
              }}
              onClick={value?.onClick}
            >
              {getText(value?.text) ?? getText(value) ?? value?.text ?? value}
            </th>
          ))}
        </tr>
        {childrenColumns.length > 0 && (
          <tr>
            {childrenColumns.map((value, index) => (
              <th
                key={`childrenColumns${index}`}
                style={{ whiteSpace: 'pre-line' }}
              >
                {getText(value) ?? value}
              </th>
            ))}
          </tr>
        )}
      </thead>
      <tbody className={className.tbody}>
        {!isEmpty(children?.props?.children) || children?.length > 0 ? (
          children
        ) : (
          <tr>
            <td colSpan={flatColumns.length}>
              {showLoading
                ? getText('loading')
                : message.code
                ? getErrorMessage(message.code, message.error)
                : getErrorMessage(RESPONSE_CODE.NotFoundData)}
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

List.propTypes = {
  // 클래스 이름
  className: PropTypes.shape({
    table: PropTypes.string,
    thead: PropTypes.string,
    tbody: PropTypes.string
  }),

  // 컬럼 목록
  // NOTE: Element를 포함할 수 있으므로 타입 유효성 확인 예외 처리
  columns: PropTypes.array,
  // columns: PropTypes.arrayOf(
  //   PropTypes.oneOfType([
  //     PropTypes.string,
  //     PropTypes.shape({
  //       text: PropTypes.string,
  //       className: PropTypes.string,
  //       colSpan: PropTypes.number,
  //       style: PropTypes.object,
  //       childrens: PropTypes.arrayOf(PropTypes.string),
  //       onClick: PropTypes.func
  //     })
  //   ])
  // ),

  // 메시지
  message: PropTypes.shape({
    code: PropTypes.string,
    error: PropTypes.string
  }),

  // 로딩 표시 여부
  showLoading: PropTypes.bool
};
List.defaultProps = {
  className: {
    table: '',
    thead: ''
  },
  columns: [],
  message: {},
  showLoading: false,
  tableRef: null
};

export default List;
